export default "__VITE_ASSET__D7G01tfW__"